import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductEntityParams {
  productId: number;
}
export class ProductEntity extends BaseEntityClass {
  productId: number;
  constructor(params: ProductEntityParams) {
    super();
    this.type = "product";
    this.entity_version = 2;
    this.productId = params.productId;
  }
}
